import React from 'react'
import styled from 'styled-components'
import { useWallet } from 'use-wallet'
import { Switch } from 'react-router-dom'
import Button from '../../components/Button'
import Page from '../../components/Page'
import Spacer from '../../components/Spacer'

import WalletProviderModal from '../../components/WalletProviderModal'

import useModal from '../../hooks/useModal'

const Home: React.FC = () => {
  const { account } = useWallet()
  const [onPresentWalletProviderModal] = useModal(<WalletProviderModal />)

  return (
    <Switch>
      <Page>
        {!!account ? (
          <>
            <Spacer size="lg" />
            <StyledTable>
              <thead>
                <StyledTableRow>
                  <StyledTableHeader>ID</StyledTableHeader>
                  <StyledTableHeader>User</StyledTableHeader>
                  <StyledTableHeader>Participation Count</StyledTableHeader>
                  <StyledTableHeader>Amount Won</StyledTableHeader>
                </StyledTableRow>
              </thead>
              <tbody>
                <StyledTableRow>
                  <StyledTableData>1</StyledTableData>
                  <StyledTableData>
                    0x89f70fa9f439dbd0a1bc22a09befc56ada04d9b4
                  </StyledTableData>
                  <StyledTableData>4</StyledTableData>
                  <StyledTableData>1.3 ETH</StyledTableData>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableData>2</StyledTableData>
                  <StyledTableData>
                    0x10d4b24938f6de7ae4048c7273f09c50d5caf4d9
                  </StyledTableData>
                  <StyledTableData>2</StyledTableData>
                  <StyledTableData>0.73 ETH</StyledTableData>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableData>3</StyledTableData>
                  <StyledTableData>
                    0xdfa34b505a5a0d65414dc759711f812aee062e2b
                  </StyledTableData>
                  <StyledTableData>1</StyledTableData>
                  <StyledTableData>0.3 ETH</StyledTableData>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableData>4</StyledTableData>
                  <StyledTableData>
                    0x9b95C44406150A66999A6716dA126f7b6d27f4c5
                  </StyledTableData>
                  <StyledTableData>1</StyledTableData>
                  <StyledTableData>0.17 ETH</StyledTableData>
                </StyledTableRow>
              </tbody>
            </StyledTable>
          </>
        ) : (
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
            }}
          >
            <Button
              onClick={onPresentWalletProviderModal}
              text="🔓 Unlock Wallet"
            />
          </div>
        )}
      </Page>
    </Switch>
  )
}

const StyledInfo = styled.div`
  color: ${(props) => props.theme.color.grey[500]};
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  align-items: center;
  display: flex;
  flex: 1;
  justify-items: center;
  justify-content: center;
  > b {
    color: ${(props) => props.theme.color.grey[600]};
  }
`

const StyledTable = styled.table`
  width: 80%;
  border-collapse: collapse;
  border-spacing: 2px;
  border: 1px solid #939da7;
`

const StyledTableRow = styled.tr`
  border-bottom: 1px solid #939da7;
  padding: 16px 0;
`

const StyledTableData = styled.td`
  text-align: center;
  color: #939da7;
  padding: 16px 0;
  min-width: 50px;
`

const StyledTableDataLoader = styled.td`
  text-align: center;
  padding: 16px 0;
  min-width: 50px;
`

const StyledTableHeader = styled.th`
  color: #fff;
  padding: 16px 0;
`

export default Home
